<template>
  <div>
    <LayoutContent>
      <SectionTitle :label="$t('label.makeAppointment')" />
      <section class="mb-4">
        <span class="d-flex align-center mb-2">
          <span class="mr-1 d-flex text-center" style="width: 50px; height: 50px">
            <BrandIcon class="ma-auto" style="width: 15px" />
          </span>
          <h4 class="primary--text text--darken-1">
            {{ $t('label.brand') }}
          </h4>
        </span>
        <v-container fluid>
          <div class="salon-options__wrapper">
            <BrandOptionCard
              v-for="brand in brandList"
              v-model="appointmentBrand"
              :key="brand.name"
              :brand="brand"
              @input="setSalonBrand"
              :disabled="appointmentEdit !== null || (storeBrandId && storeId)"
            />
          </div>
        </v-container>
      </section>
      <section class="mb-4" ref="salons" v-show="showSalons">
        <span class="d-flex align-center mb-2">
          <span class="mr-1 d-flex text-center" style="width: 50px; height: 50px">
            <SalonIcon class="ma-auto" />
          </span>
          <h4 class="primary--text text--darken-1">
            {{ $t('label.salon') }}
          </h4>
        </span>
        <v-container fluid>
          <div class="salon-options__wrapper">
            <SalonOptionCard
              v-for="salon in storeList"
              v-model="appointmentSalon"
              :key="salon.branch_name"
              :salon="salon"
              :disabled="appointmentEdit !== null || (storeBrandId && storeId)"
              @input="setAppointmentFormSalon"
            />
          </div>
        </v-container>
      </section>
      <v-expand-transition>
        <section class="mb-4" v-show="showStylists" ref="stylists">
          <span class="d-flex align-center mb-2">
            <span class="mr-1 d-flex text-center" style="width: 50px; height: 50px">
              <StylistIcon class="ma-auto" />
            </span>
            <h4 class="primary--text text--darken-1">
              {{ $t('label.hairStylist') }}
            </h4>
          </span>
          <v-container fluid v-if="availableStylists.length > 0">
            <StylistOptionCard
              v-model="appointmentStylist"
              v-for="stylist in availableStylists"
              :key="stylist.name"
              :stylist="stylist"
              :disabled="appointmentSalon === ''"
              @input="setAppointmentFormStylist"
            />
          </v-container>
          <v-container v-else>
            <p class="font-weight-bold">
              {{ $t('message.noStylistAvailable') }}
            </p>
          </v-container>
        </section>
      </v-expand-transition>
      <v-expand-transition>
        <v-row tag="section" class="mb-4" v-show="showDropdowns" ref="dateTime">
          <v-col :xs="6" :sm="4" :cols="12">
            <span class="d-flex align-center mb-2">
              <DateIcon class="mr-1" />
              <h4 class="primary--text text--darken-1">
                {{ $t('label.date') }}
              </h4>
            </span>
            <DateSelect v-model="appointmentDate" :label="$t('label.select')" :disabled="!appointmentStylist" :availableDates="availableDates" :min="tomorrow" />
          </v-col>
          <v-col :xs="6" :sm="4" :cols="12">
            <span class="d-flex align-center mb-2">
              <TimeIcon class="mr-1" />
              <h4 class="primary--text text--darken-1">
                {{ $t('label.time') }}
              </h4>
            </span>
            <DropdownField v-model="appointmentTimeSlots" :dropdownOptions="timeSlots" :label="$t('label.select')" :disabled="!appointmentStylist" />
          </v-col>
          <v-col :xs="6" :sm="4" :cols="12">
            <span class="d-flex align-center mb-2">
              <ServicesIcon class="mr-1" />
              <h4 class="primary--text text--darken-1">
                {{ $t('label.service') }}
              </h4>
            </span>
            <DropdownField v-model="appointmentServices" :dropdownOptions="availableServices" :label="$t('label.select')" :disabled="!appointmentStylist" multiple item-text="name" item-value="id">
              <template #prepend-item>
                <v-list-item ripple>
                  <v-list-item-action></v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>{{ $t('label.serviceName') }}</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-content>
                    <v-list-item-title class="text-right">{{ $t('label.from') }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
              <template #item="{ item, attrs }">
                <div class="d-flex align-center w-100">
                  <v-simple-checkbox class="mr-2" v-bind="attrs" :value="attrs.inputValue" :ripple="false"></v-simple-checkbox>
                  <div class="dropdown-desc">{{ item.name }}</div>
                  <div class="ml-auto">{{ item.currency }} {{ item.price.toFixed(2) }}</div>
                </div>
              </template>
            </DropdownField>
          </v-col>
        </v-row>
      </v-expand-transition>
      <v-expand-transition>
        <section class="mb-4 white pa-4 rounded-lg" v-show="showRemarks" ref="remark">
          <label for="appointmentRemarks">
            <h4 class="primary--text text--darken-1">
              {{ $t('label.remarks') }}
            </h4>
          </label>
          <textarea class="appointment-remarks d-block w-100" id="appointmentRemarks" v-model="appointmentRemarks" />
        </section>
      </v-expand-transition>
    </LayoutContent>
    <Spacer />
    <v-expand-transition>
      <v-sheet class="bottom-bar green-gradient-down rounded-tl-lg rounded-tr-lg" v-show="showBottomBar">
        <v-container fluid class="py-3 d-flex align-center justify-center">
          <app-button class="px-8" :label="$t('button.book')" @click="submitBooking" />
        </v-container>
      </v-sheet>
    </v-expand-transition>

    <!-- Error make appointment  -->
    <v-dialog v-model="errorDialog" max-width="450px">
      <v-card class="d-flex flex-column px-16 rounded-lg" min-height="30vh">
        <v-card-text class="mt-10">
          <p class="text-center font-weight-medium text-subtitle-1 px-4">
            {{ errorMessage }}
          </p>
        </v-card-text>
        <v-card-actions class="d-flex flex-column align-stretch">
          <app-button invert gradient :label="$t('button.okay')" @click="errorDialog = false" class="py-5 px-10 mb-8" />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import { mapFields } from 'vuex-map-fields'

import LayoutContent from '@/views/layouts/LayoutContent'
import SectionTitle from '@/components/SectionTitle.vue'
import BrandIcon from '@/assets/icons/brand-icon.svg'
import SalonIcon from '@/assets/icons/salon-icon.svg'
import StylistIcon from '@/assets/icons/stylist-icon.svg'
import TimeIcon from '@/assets/icons/appointment-time.svg'
import DateIcon from '@/assets/icons/appointment-date.svg'
import ServicesIcon from '@/assets/icons/appointment-services.svg'
import DateSelect from '@/components/DateSelect.vue'
import DropdownField from '@/components/fields/DropdownField.vue'
import BrandOptionCard from '@/components/appointment/BrandOptionCard.vue'
import SalonOptionCard from '@/components/appointment/SalonOptionCard.vue'
import StylistOptionCard from '@/components/appointment/StylistOptionCard.vue'
import Spacer from '@/components/Spacer.vue'
import { uiHelper } from '@/utils'
import { ROUTE_NAME } from '@/constants/route.constants'

export default {
  name: 'MakeAppointment',
  props: ['bookingId', 'storeBrandId', 'storeId'],
  components: {
    LayoutContent,
    SectionTitle,
    BrandIcon,
    SalonIcon,
    StylistIcon,
    TimeIcon,
    DateIcon,
    ServicesIcon,
    DateSelect,
    DropdownField,
    BrandOptionCard,
    SalonOptionCard,
    StylistOptionCard,
    Spacer
  },

  data() {
    return {
      today: uiHelper.getTodayDate(),
      appointmentEdit: null,
      errorDialog: false,
      errorMessage: '',
      appointmentBrand: ''
    }
  },

  computed: {
    ...mapState('common', ['storeList', 'brandList']),
    ...mapState('appointment', ['availableStylists', 'availableDates', 'availableServices', 'availableTimeSlots', 'upcomingAppointments']),
    ...mapFields('appointment', [
      'appointmentForm',
      'appointmentForm.appointmentSalon',
      'appointmentForm.appointmentStylist',
      'appointmentForm.appointmentDate',
      'appointmentForm.appointmentTimeSlots',
      'appointmentForm.appointmentServices',
      'appointmentForm.appointmentRemarks',
      'appointmentForm.appointmentBookingId'
    ]),
    showSalons() {
      return this.appointmentBrand
    },

    showStylists() {
      return this.appointmentSalon
    },

    showDropdowns() {
      return this.appointmentStylist
    },

    showRemarks() {
      if (this.appointmentEdit && this.appointmentEdit.stylist_id === this.appointmentForm.appointmentStylist) {
        return this.appointmentTimeSlots && this.appointmentServices?.length > 0
      }

      let isDateTimeSelected = this.appointmentDate && this.availableTimeSlots.indexOf(this.appointmentTimeSlots) !== -1 && this.appointmentServices?.length > 0
      if (isDateTimeSelected) {
        this.goto('remark')
      }
      return isDateTimeSelected
    },

    showBottomBar() {
      return this.showStylists && this.showDropdowns && this.showRemarks
    },

    salonWatcher() {
      return { appointmentSalon: this.appointmentForm.appointmentSalon }
    },

    formWatchers() {
      return {
        appointmentSalon: this.appointmentForm.appointmentSalon,
        appointmentStylist: this.appointmentForm.appointmentStylist,
        appointmentDate: this.appointmentForm.appointmentDate,
        appointmentTimeSlots: this.appointmentForm.appointmentTimeSlots
      }
    },

    timeSlots() {
      // edit appointment
      if (this.appointmentEdit) {
        return [this.appointmentEdit.timeslot, ...this.availableTimeSlots].sort(
          (a, b) => new Date(`01/01/2020 ${a.slice(0, 5)} ${a.slice(5, 7)}`).getTime() - new Date(`01/01/2020 ${b.slice(0, 5)} ${b.slice(5, 7)}`).getTime()
        )
      }
      return this.availableTimeSlots
    },

    appointmentEdited() {
      return !(
        this.appointmentForm.appointmentDate == this.appointmentEdit.book_date &&
        this.appointmentForm.appointmentTimeSlots == this.appointmentEdit.timeslot &&
        this.appointmentForm.appointmentSalon == this.appointmentEdit.store_id &&
        this.appointmentForm.appointmentStylist == this.appointmentEdit.stylist_id &&
        uiHelper.arrayEqual(
          this.appointmentForm.appointmentServices,
          this.appointmentEdit.services.map((service) => service.id)
        ) &&
        this.appointmentForm.appointmentRemarks == this.appointmentEdit.remarks
      )
    }
  },

  mounted() {
    console.log('HERERRERERE', this.$route.hash)
    // edit appointment
    if (this.bookingId) {
      if (this.upcomingAppointments.length > 0) {
        this.appointmentEdit = this.upcomingAppointments.filter((appointment) => {
          return appointment.booking_id == this.bookingId
        })[0]
        this.appointmentBrand = this.appointmentEdit.brand_id
        this.setSalonBrand(this.appointmentEdit.brand_id)
        this.setAppointmentForm({
          appointmentBookingId: this.appointmentEdit.booking_id,
          appointmentSalon: this.appointmentEdit.store_id,
          appointmentDate: this.appointmentEdit.book_date,
          appointmentTimeSlots: this.appointmentEdit.timeslot,
          appointmentServices: this.appointmentEdit.services.map((service) => service.id),
          appointmentStylist: this.appointmentEdit.stylist_id,
          appointmentRemarks: this.appointmentEdit.remarks
        })
      }
    } else if (this.storeBrandId && this.storeId) {
      this.setSalonBrand(this.storeBrandId)
    } else this.getStoreList()
  },

  beforeRouteLeave(to, from, next) {
    console.log('beforeRouteLeave')
    this.resetAppointmentForm()
    this.appointmentDate = ''
    this.appointmentTimeSlots = ''
    this.appointmentServices = ''
    this.appointmentStylist = ''
    next()
  },

  watch: {
    salonWatcher(form) {
      this.checkAvailableStylists(form).then(() => {
        this.goto('stylists')
      })
    },

    formWatchers(form) {
      this.checkAppointmentSlot(form).then(() => this.goto('dateTime'))
    },
    $route(to, from) {
      if (to.hash === '') {
        this.resetAppointmentForm()
        this.appointmentDate = ''
        this.appointmentTimeSlots = ''
        this.appointmentServices = ''
        this.appointmentStylist = ''
        this.storeBrandId = null
        this.storeId = null
        this.appointmentBrand = ''
      }
    }
  },

  methods: {
    ...mapActions('appointment', ['checkAvailableStylists', 'checkAppointmentSlot', 'bookAppointment', 'editAppointment']),
    ...mapActions('common', ['getStoreList', 'getStoreDetails']),
    ...mapMutations('appointment', ['setAppointmentForm', 'resetAppointmentForm', 'setAppointmentFormSalon', 'setAppointmentFormStylist']),
    submitBooking() {
      if (this.appointmentEdit) {
        if (this.appointmentEdited) {
          const form = Object.assign({}, this.appointmentForm)
          let requestBody = {}
          if (form.appointmentDate == this.appointmentEdit.book_date && form.appointmentTimeSlots == this.appointmentEdit.timeslot) {
            requestBody = {
              booking_id: form.appointmentBookingId,
              store_id: form.appointmentSalon,
              stylist_id: form.appointmentStylist,
              service_ids: `{"service_ids":[${form.appointmentServices}]}`,
              remarks: form.appointmentRemarks
            }
          } else {
            requestBody = {
              booking_id: form.appointmentBookingId,
              store_id: form.appointmentSalon,
              stylist_id: form.appointmentStylist,
              date: form.appointmentDate,
              time: form.appointmentTimeSlots.split(' - ')[0],
              service_ids: `{"service_ids":[${form.appointmentServices}]}`,
              remarks: form.appointmentRemarks
            }
          }
          this.editAppointment(requestBody)
            .then(() => {
              this.$router.push({ name: ROUTE_NAME.APPOINTMENT_COMPLETE })
            })
            .catch((err) => {
              this.errorDialog = true
              this.errorMessage = err.error_message
            })
        } else {
          this.$router.push({
            name: this.$constants.ROUTE_NAME.APPOINTMENT_DETAIL,
            params: { id: this.bookingId }
          })
        }
      } else {
        this.bookAppointment(this.appointmentForm)
          .then(() => {
            this.$router.push({ name: ROUTE_NAME.APPOINTMENT_COMPLETE })
          })
          .catch((err) => {
            this.errorDialog = true
            this.errorMessage = err.error_message
          })
      }
    },
    setSalonBrand(selectedBrandId) {
      this.appointmentBrand = selectedBrandId
      this.resetAppointmentForm()
      this.getStoreList({ brand_id: this.appointmentBrand }).then(() => {
        if (this.storeId) this.appointmentSalon = this.storeId
        this.goto('salons')
      })
    },
    goto(refName) {
      let top = 0
      let element = null
      switch (refName) {
        case 'salons':
          top = this.$refs.salons.offsetTop
          element = this.$refs.salons
          break
        case 'stylists':
          top = this.$refs.stylists.offsetTop
          element = this.$refs.stylists
          break
        case 'dateTime':
          top = this.$refs.dateTime.offsetTop
          element = this.$refs.dateTime
          break
        case 'remark':
          top = this.$refs.remark.offsetTop
          element = this.$refs.remark
          break
      }
      if (this.$vuetify.breakpoint.smAndUp) element.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' })
      else element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' })
    }
  }
}
</script>

<style lang="scss" scoped>
.salon-options__wrapper {
  display: grid;
  grid-template-columns: 1fr;
  column-gap: 2rem;
  row-gap: 1rem;

  @media only screen and (min-width: 1000px) {
    grid-template-columns: 1fr 1fr;
  }
}

.appointment-remarks {
  height: 5rem;
}

.dropdown-desc {
  max-width: 12rem;
  text-overflow: ellipsis;
  overflow-x: hidden;
  white-space: nowrap;
}
</style>
